import React from "react";
import { Helmet } from "react-helmet";
import logo from "../assets/image/logo.png";
import connectFailIcon from "../assets/image/connect_fail_icon.png";

const ConnectFailed: React.FC = () => {
  return (
    <div className="flex flex-col items-center p-4 md:p-10 gap-y-4 justify-center min-h-screen w-full bg-white">
      <div className="flex flex-col items-center p-0 md:p-10 gap-y-4 w-full">
        <div className="w-full max-w-2xl border p-10 rounded-3xl shadow-md bg-white relative">
          {/* Head / Meta */}
          <Helmet>
            <title>Samitivej - Connect Failed</title>
            <meta name="description" content="Samitivej Virtual Hospital" />
            {/* Add other meta tags here */}
          </Helmet>

          {/* Logo */}
          <div className="text-center mb-8">
            <img
              src={logo}
              alt="Samitivej Logo"
              className="w-[172px] h-[64px] mx-auto"
            />
          </div>

          {/* Nurse Image */}
          <div className="text-center">
            <img
              src={connectFailIcon}
              alt="Connect Failed"
              className="h-[200px] w-[200px] object-cover object-top bg-[#f9fbfa] p-12 mt-8 mb-8 inline-block"
            />
          </div>

          {/* Error Messages */}
          <div className="text-center text-gray-500 text-md space-y-2 mb-6">
            <p className="">พบข้อผิดพลาด / Something went wrong</p>
            <p className="">
              กรุณาทำรายการใหม่อีกครั้งผ่านแอปพลิเคชันเมืองไทยประกันชีวิต
            </p>
            <p className="">
              Please restart your session from MTL application.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectFailed;
